module.exports = __webpack_public_path__ + "Frame419-7e41f71f.webp";